import * as L from 'leaflet'
// import 'leaflet.vectorgrid'
import { CanvasShipUtils } from './utils/CanvasShipUtils'
import { CommUtils } from './utils/CommUtils' // 添加缺失的工具类导入
import type { BoundsExpression, Point, PointExpression } from 'leaflet'
// 1. 定义选项接口
interface CanvasShipLayerOptions extends L.GridLayerOptions {
  iconUrl: string
  // 添加其他自定义选项
  shipSize?: number
  color?: string
}

const CanvasShipLayer = L.GridLayer.extend({
  version: '1.0.202411041506',
  options: {
    laneOptions: {
      drawType: 'solid',
      radius: 1,
      enableMousemove: true,
      enableLaneClick: true,
      colorByType: {
        1: '#ff0000',
        2: '#00ff00',
        3: '#0000ff',
        4: '#ffff00',
        5: '#ff00ff',
        6: '#00ffff',
        7: '#ff0000',
        8: '#00ff00',
        9: '#0000ff',
      },
      colorByDefault: 'yellow',
      shipDetailURL: undefined,
      isShowTileBox: true,
      isDrawBoundPoint: false,
      fieldMap: {
        name: 'name',
        mmsi: 'mmsi',
        type: 't',
        sog: 's',
        hdg: 'h',
        cog: 'c',
        naviStatus: 'n',
        utc: 'u',
        key: 'k',
      },
    },
    wmsParams: undefined,
    onLoad: undefined,
  },
  initialize(url: string, options?: CanvasShipLayerOptions) {
    this.setOptions(url, options)
    this.loadVectorTileDependencies()
    const tooltip = L.tooltip({
      direction: 'top',
      opacity: 0.8,
      className: 'leaflet-gcs-tooltip',
    })
    this._tooltip = tooltip
    const iconUrl =
      options?.iconUrl ||
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAYAAACpF6WWAAAACXBIWXMAAAsSAAALEgHS3X78AAAApklEQVQ4jWP8z8DgwADB2MAChv//H2CIMzIqMDAwJODQ84AFamABAwPDBSwKNuDQKIDDIQYgc1ignAsM///jci0m+P//AlZDGRkPgCgmog0iAYwaSn0ASqcK4CQCiVHKACMjKEkxMP7//39oeH/oGEqjiGJgaADnY1LyPm5DR/M+jQyFFdIGsEBGAwVYUwUklidgUQ8v+bEZBgMf8Ihj03eAgYHhAQAxnSv3UtZ4ZQAAAABJRU5ErkJggg=='
    const icon = L.icon({
      iconUrl,
      iconSize: [21, 21],
      iconAnchor: [10, 10],
    })
    this._selector = L.marker([0, 0], { icon })
    this._abortController_shipDetail = undefined
    this._setTimeout_shipDetail = undefined
  },
  getVersion() {
    return this.version
  },
  setOptions(url: string | null, options: { laneOptions: undefined } | null) {
    if ((url && url !== '' && (this._url = url), options)) {
      const optionsCopy = {
        ...options,
      }
      const laneOptions = options.laneOptions
      delete optionsCopy.laneOptions
      L.Util.setOptions(this, optionsCopy)
      options.laneOptions &&
        (this.options.laneOptions = L.extend(
          this.options.laneOptions,
          laneOptions
        ))
    }
    this._map && this.redraw()
    return this.options
  },
  createTile(coords: any, done: any) {
    const canvas = document.createElement('canvas')
    const tileSize = this.getTileSize()
    canvas.width = tileSize.x
    canvas.height = tileSize.y
    const context = canvas.getContext('2d')
    return this.loadTileData(coords, context, done, canvas), canvas
  },
  onAdd(map: any) {
    window.L.GridLayer.prototype.onAdd.call(this, map)
    this.on('load', this._onLoaded, this)
    this.on('tileload', this._onTileLoaded, this)
    this.on('tileunload', this._onTileUnload, this)
    map.on('zoomstart', this._onZoomLevelChange, this)
    map.on('baselayerchange', this._onBaselayerchange, this)
    this.options.laneOptions &&
      this.options.laneOptions.enableMousemove === true &&
      map.on('mousemove', this._onMouseMove, this)
    this.options.laneOptions &&
      this.options.laneOptions.enableLaneClick === true &&
      map.on('click', this._onMapClick, this)
  },
  onRemove(map: any) {
    this._tooltip.remove()
    this._selector.remove()
    this._setTimeout_shipDetail &&
      (clearTimeout(this._setTimeout_shipDetail),
      (this._setTimeout_shipDetail = null))
    this._abortController_shipDetail &&
      (this._abortController_shipDetail.abort(),
      (this._abortController_shipDetail = null))
    L.GridLayer.prototype.onRemove.call(this, map)
    this.off('tileload', this._onTileLoaded, this)
    map.off('mousemove', this._onMouseMove, this)
    map.off('zoomstart', this._onZoomLevelChange, this)
    map.off('baselayerchange', this._onBaselayerchange, this)
    map.off('click', this._onMapClick, this)
  },
  _abortLoading() {
    for (const tileKey in this._tiles) {
      if (this._tiles[tileKey].coords.z !== this._tileZoom) {
        const tileElement = this._tiles[tileKey].el
        if (!tileElement.dataLoaded) {
          tileElement.abortController.abort()
          L.DomUtil.remove(tileElement)
          delete this._tiles[tileKey]
        }
      }
    }
  },
  _onMouseMove(event: any) {
    const featureInfo = this._findFeature(event)
    if (featureInfo && featureInfo.feature) {
      this.selectorShip(featureInfo.feature, featureInfo.center)
      this.openTooltip(featureInfo.feature, featureInfo.center)
    } else {
      this._map.getContainer().style.cursor = 'default'
      this._tooltip.remove()
      this._selector.remove()
    }
  },
  _onMapClick(event: any) {
    const featureInfo = this._findFeature(event),
      feature = featureInfo ? featureInfo.feature : null,
      center = featureInfo ? featureInfo.center : null
    this.getShipDetail(feature, (featureDetail: any) => {
      this.fire('lane-click', {
        feature: featureDetail,
        center,
      })
    })
  },
  _onZoomLevelChange(event: any) {
    // Placeholder implementation for zoom level change
    console.log('Zoom level changed:', event)
  },
  _onBaselayerchange() {
    this.redraw()
  },
  _onTileLoaded(event: {
    tile: { points: any; bounds_points: any[] }
    coords: { scaleBy: (arg0: any) => any; z: any }
  }) {
    const points = event.tile.points
    if (points && points) {
      const tileSize = this.getTileSize()
      const tileBounds = event.coords.scaleBy(tileSize)
      const bounds = L.bounds([
        [tileBounds.x, tileBounds.y],
        [tileBounds.x + tileSize.x, tileBounds.y + tileSize.y],
      ])
      points.forEach(
        (point: {
          geometry: any[][]
          latlng: any
          point: Point
          isBoundPoint?: boolean
        }) => {
          const geometry = point.geometry[0][0]
          const x = geometry.x / 10 + tileBounds.x
          const y = geometry.y / 10 + tileBounds.y
          const pointObj = L.point(x, y)
          const latLng = this._map.unproject(pointObj, event.coords.z)
          point.latlng = latLng
          point.point = pointObj
          if (this.options.laneOptions.isDrawBoundPoint === true) {
            const boundBox = L.bounds(
              [pointObj.x - 8, pointObj.y - 8],
              [pointObj.x + 8, pointObj.y + 8]
            )
            if (bounds.contains(boundBox)) {
              const boundPoint = {
                ...point,
              }
              boundPoint.isBoundPoint = true
              event.tile.bounds_points.push(boundPoint)
            }
          }
        }
      )
    }
  },

  _onTileUnload(event: { tile: any }) {
    const tile = event.tile
    if (tile && tile && tile.abortController) {
      tile.abortController?.abort()
      tile.abortController = null
    }
  },
  _onLoaded(event: any) {
    if (this.options.laneOptions.isDrawBoundPoint) {
      this._drawAllBounds()
    }
    if (this.options.onLoad) {
      this.options.onLoad(event)
    }
  },
  getBBOXByCoords(coords: any) {
    const nwSe = this._tileCoordsToNwSe(coords)
    const crs = this._map.options.crs
    const bounds = L.bounds(crs.project(nwSe[0]), crs.project(nwSe[1]))
    const min = bounds.min
    const max = bounds.max
    return (
      Number.parseFloat(this.options.wmsParams.version) >= 1.3 &&
      'EPSG:4326' === crs.code
        ? [min?.y ?? 0, min?.x ?? 0, max?.y ?? 0, max?.x ?? 0]
        : [min?.x ?? 0, min?.y ?? 0, max?.x, max?.y]
    ).join(',')
  },
  getTileUrl(coords: { x: any; y: any; z: any }) {
    const crsCode = this._map.options.crs.code
    let url = this._url.replaceAll('{srs}', crsCode)
    if (this.options.wmsParams) {
      const bbox = this.getBBOXByCoords(coords)
      url = url.replaceAll('{bbox}', bbox)
    } else {
      url = url.replaceAll('{x}', coords.x)
      url = url.replaceAll('{y}', coords.y)
      url = url.replaceAll('{z}', coords.z)
    }
    return url
  },
  loadVectorTileDependencies() {
    // 检查是否已加载 PBF 和 VectorTile
    if ((window as any).Pbf && (window as any).VectorTile) {
      return {
        Pbf: (window as any).Pbf,
        VectorTile: (window as any).VectorTile,
      }
    }

    // 创建一个 Promise 来等待脚本加载完成
    return new Promise((resolve, reject) => {
      // 加载 PBF 库
      const pbfScript = document.createElement('script')
      pbfScript.src =
        'https://unpkg.com/Leaflet.VectorGrid@1.3.0/dist/Leaflet.VectorGrid.min.js' // 使用 CDN
      pbfScript.onload = () => {
        resolve({
          Pbf: (window as any).Pbf,
          VectorTile: (window as any).VectorTile,
        })
      }
      pbfScript.onerror = reject
      document.head.appendChild(pbfScript)
    })
  },
  loadTileData(
    coords: { scaleBy: (arg0: any) => any },
    context: any,
    done: (arg0: null, arg1: any) => void,
    canvas: {
      abortController: AbortController | null
      dataLoaded: boolean
      points: any[]
      bounds_points: never[]
    }
  ) {
    const url = this.getTileUrl(coords)
    if (canvas.abortController) {
      canvas.abortController.abort()
      canvas.abortController = null
    }
    canvas.abortController = new AbortController()
    const tileSize = coords.scaleBy(this.getTileSize())
    if (this.options.laneOptions.isShowTileBox) {
      this.drawTileBox(context, coords)
    }

    this.loadArrayBuffer(url, canvas.abortController.signal)
      .then((arrayBuffer: any) => {
        const pbf = new (window as any).Pbf(arrayBuffer)
        const vectorTile = new (window as any).VectorTile(pbf)
        canvas.dataLoaded = false
        canvas.points = []
        canvas.bounds_points = []
        for (const layerName in vectorTile.layers) {
          const layer = vectorTile.layers[layerName]
          const features = []
          for (let i = 0; i < layer.length; i++) {
            const feature = layer.feature(i)
            feature.geometry = feature.loadGeometry()
            let sog = this.getFeatureProperty(feature, 'sog')
            let cog = this.getFeatureProperty(feature, 'cog')
            let hdg = this.getFeatureProperty(feature, 'hdg')
            if (hdg > 1000) {
              hdg = CommUtils.getNumberLEValue(hdg, 35900, 100, 1)
              hdg = CanvasShipUtils.xTo360(hdg)
            }
            if (cog > 1000) {
              cog = CommUtils.getNumberLEValue(cog, 35990, 100, 1)
              cog = CanvasShipUtils.xTo360(cog)
            }
            if (sog > 100) {
              sog = CommUtils.getNumberLEValue(sog, 52576, 514, 1)
            }
            feature.properties[this.options.laneOptions.fieldMap.hdg] = hdg
            feature.properties[this.options.laneOptions.fieldMap.cog] = cog
            feature.properties[this.options.laneOptions.fieldMap.sog] = sog
            this.drawFeature(tileSize, context, feature)
            if (feature.type === 1) {
              canvas.points.push(feature)
            }
            features.push(feature)
          }
          layer.features = features
        }
        done(null, canvas)
      })
      .catch((error: any) => {
        done(error, canvas)
      })
  },
  openTooltip(feature: any, point: any) {
    this.getShipDetail(feature, (featureDetail: any) => {
      this.showTooltip(featureDetail, point)
    })
  },
  getShipDetail(
    feature: { properties: any },
    callback: ((arg0: any) => void) | null
  ) {
    const mmsi = this.getFeatureProperty(feature, 'mmsi')
    if (
      mmsi === null ||
      mmsi === '' ||
      this.options.laneOptions.shipDetailURL === null ||
      this.options.laneOptions.shipDetailURL === ''
    ) {
      if (callback) {
        callback(feature)
      }
    } else {
      if (this._setTimeout_shipDetail) {
        clearTimeout(this._setTimeout_shipDetail)
        this._setTimeout_shipDetail = null
      }
      this._setTimeout_shipDetail = setTimeout(() => {
        if (this._abortController_shipDetail) {
          this._abortController_shipDetail.abort()
          this._abortController_shipDetail = null
        }
        this._abortController_shipDetail = new AbortController()
        let url = this.options.laneOptions.shipDetailURL
        url = url.replaceAll('{k}', this.getFeatureProperty(feature, 'key'))
        this.loadJson(url, this._abortController_shipDetail.signal)
          .then((data: any) => {
            feature.properties = {
              ...feature.properties,
              ...data,
            }
            if (callback) {
              callback(feature)
            }
          })
          .catch((error: any) => {
            console.error('Error parsing JSON:', error)
            if (callback) {
              callback(feature)
            }
          })
      }, 100)
    }
  },
  showTooltip(feature: any, point: any) {
    const latLng = this._map.unproject(point)
    const shipType = CanvasShipUtils.getShipTypeCN(
      Number.parseInt(this.getFeatureProperty(feature, 'type')) || 0
    )
    const content = `<div style="color: #0077ff"><span style="width: 48px;text-align: right;display: inline-block;">船舶名称：</span>${this.getFeatureProperty(
      feature,
      'name'
    )}
    </div>
    <div><span style="width: 48px;text-align: right;display: inline-block;">船舶类型：</span>${shipType}</div>
    <div><span style="width: 48px;text-align: right;display: inline-block;">速度：</span>${this.getFeatureProperty(
      feature,
      'sog'
    )} 节</div>
    <div><span style="width: 48px;text-align: right;display: inline-block;">航向：</span>${this.getFeatureProperty(
      feature,
      'cog'
    )}°</div>
    <div><span style="width: 48px;text-align: right;display: inline-block;">MMSI：</span>${this.getFeatureProperty(
      feature,
      'mmsi'
    )}</div>`

    this._tooltip.setContent(content)
    this._tooltip.setLatLng(latLng)
    if (!this._tooltip._mapToAdd) {
      this._tooltip.addTo(this._map)
    }
  },
  selectorShip(feature: any, point: any) {
    const latLng = this._map.unproject(point)
    this._map.getContainer().style.cursor = 'pointer'
    this._selector.setLatLng(latLng)
    if (!this._selector._mapToAdd) {
      this._selector.addTo(this._map)
    }
  },
  drawFeature(tileSize: any, context: any, feature: any) {
    if (this.options.laneOptions.drawType === 'dot') {
      this.drawFeatureByDot(tileSize, context, feature)
      return
    }
    this.drawFeatureBySolidOrHollow(tileSize, context, feature)
  },
  drawFeatureByDot(
    tileSize: { x: number; y: number },
    context: {
      beginPath: () => void
      fillStyle: any
      strokeStyle: string
      lineWidth: number
      arc: (
        arg0: number,
        arg1: number,
        arg2: any,
        arg3: number,
        arg4: number,
        arg5: boolean
      ) => void
      closePath: () => void
      fill: () => void
      stroke: () => void
    },
    feature: {
      type: number
      geometry: string | any[]
      isBoundPoint: boolean
      point: { x: number; y: number }
    }
  ) {
    if (feature.type === 1) {
      for (let i = 0; i < feature.geometry.length; i++) {
        context.beginPath()
        const color = this.options.laneOptions.colorByDefault
        context.fillStyle = color
        context.strokeStyle = 'transparent'
        context.lineWidth = 0
        const geometry = feature.geometry[i][0]
        let x = geometry.x / 10
        let y = geometry.y / 10
        if (feature.isBoundPoint === true) {
          x = feature.point.x - tileSize.x
          y = feature.point.y - tileSize.y
        }
        context.arc(
          x,
          y,
          this.options.laneOptions.radius,
          0,
          2 * Math.PI,
          false
        )
        context.closePath()
        context.fill()
        context.stroke()
      }
    }
  },
  drawFeatureBySolidOrHollow(
    tileSize: { x: number; y: number },
    context: {
      beginPath: () => void
      fillStyle: string
      strokeStyle: string
      lineWidth: number
      moveTo: (arg0: number, arg1: number) => void
      lineTo: (arg0: number, arg1: number) => void
      fill: () => void
      stroke: () => void
    },
    feature: {
      type: number
      geometry: string | any[]
      isBoundPoint: boolean
      point: { x: number; y: number }
    }
  ) {
    const drawType = this.options.laneOptions.drawType || 'solid'
    const sog = this.getFeatureProperty(feature, 'sog')
    const cog = this.getFeatureProperty(feature, 'cog')
    const hdg = this.getFeatureProperty(feature, 'hdg')
    const isStopped =
      Number.parseInt(this.getFeatureProperty(feature, 'naviStatus')) === 1 ||
      Number.parseInt(this.getFeatureProperty(feature, 'naviStatus')) === 5 ||
      Number.parseInt(this.getFeatureProperty(feature, 'sog')) <= 0
    if (feature.type === 1) {
      for (let i = 0; i < feature.geometry.length; i++) {
        context.beginPath()
        const color = this.getColorByType(feature)
        let lineWidth = 0
        if (drawType === 'hollow') {
          context.fillStyle = 'transparent'
          context.strokeStyle = color
          lineWidth = 0.5
        } else {
          context.fillStyle = color
          context.strokeStyle = '#888'
          lineWidth = 0
        }
        context.lineWidth = lineWidth
        const geometry = feature.geometry[i][0]
        let x = geometry.x / 10
        let y = geometry.y / 10
        if (feature.isBoundPoint === true) {
          x = feature.point.x - tileSize.x
          y = feature.point.y - tileSize.y
        }
        let point = L.point(x, y)
        if (isStopped) {
          point = point.add(L.point(0, -5 + lineWidth))
          context.moveTo(point.x, point.y)
          point = point.add(L.point(-5 + lineWidth, 5 - lineWidth))
          context.lineTo(point.x, point.y)
          point = point.add(L.point(5 - lineWidth, 5 - lineWidth))
          context.lineTo(point.x, point.y)
          point = point.add(L.point(5 - lineWidth, -5 + lineWidth))
          context.lineTo(point.x, point.y)
          point = point.add(L.point(-5 + lineWidth, -5 + lineWidth))
          context.lineTo(point.x, point.y)
        } else {
          let angle = CanvasShipUtils.getAngle(hdg, cog, sog)
          angle = Number(Number(angle) * (Math.PI / 180)) || 0
          console.info(angle)
          const point1 = this.rotate(L.point(0, -7 + lineWidth), angle)
          const point2 = this.rotate(
            L.point(-4 + lineWidth, 14 - lineWidth),
            angle
          )
          const point3 = this.rotate(
            L.point(8 - lineWidth, 0 - lineWidth),
            angle
          )
          const point4 = this.rotate(
            L.point(-4 + lineWidth, -14 + lineWidth),
            angle
          )
          point = point.add(point1)
          context.moveTo(point.x, point.y)
          point = point.add(point2)
          context.lineTo(point.x, point.y)
          point = point.add(point3)
          context.lineTo(point.x, point.y)
          point = point.add(point4)
          context.lineTo(point.x, point.y)
        }
        context.fill()
        context.stroke()
      }
    }
  },
  _drawAllBounds() {
    for (const tileKey in this._tiles) {
      const context = this._tiles[tileKey].el.getContext('2d')
      const tileSize = this.getTileSize()
      const padding = 8
      const tileBounds = this._tiles[tileKey].coords.scaleBy(tileSize)
      const tileBox = L.bounds([
        [tileBounds.x - padding, tileBounds.y - padding],
        [
          tileBounds.x + tileSize.x + padding,
          tileBounds.y + tileSize.y + padding,
        ],
      ])
      const features = this._findFeatureByBounds(tileBox)
      let bounds: any[] = []
      if (features && features.length > 0) {
        bounds = bounds.concat(features)
      }
      bounds.forEach((feature) => {
        this.drawFeature(tileBounds, context, feature)
      })
    }
  },
  _findFeature(event: { latlng: any }) {
    let feature = null
    let center = null
    const point = this._map.project(event.latlng)
    const tileSize = this.getTileSize()
    for (const tileKey in this._tiles) {
      const points = this._tiles[tileKey].el.points
      if (!points || points === null || points.length === 0) {
        continue
      }
      const tileBounds = this._tiles[tileKey].coords.scaleBy(tileSize)
      if (
        L.bounds([
          [tileBounds.x, tileBounds.y],
          [tileBounds.x + tileSize.x, tileBounds.y + tileSize.y],
        ]).contains(point)
      ) {
        feature = points.find((pointFeature: { point: any }) => {
          const pointObj = pointFeature.point,
            boundBox = [
              [pointObj.x - 8, pointObj.y - 8],
              [pointObj.x + 8, pointObj.y + 8],
            ],
            bounds = L.bounds(boundBox.map(([x, y]) => L.point(x, y)))
          if (bounds.contains(point)) {
            center = bounds.getCenter()
            return true
          }
          return false
        })
        break
      }
    }
    return {
      feature,
      center,
    }
  },
  _findFeatureByBounds(bounds: PointExpression | BoundsExpression) {
    let features: any[] = []
    const tileSize = this.getTileSize()
    for (const tileKey in this._tiles) {
      const boundPoints = this._tiles[tileKey].el.bounds_points
      if (boundPoints === null || boundPoints.length === 0) {
        continue
      }
      const tileBounds = this._tiles[tileKey].coords.scaleBy(tileSize)
      if (
        L.bounds([
          [tileBounds.x, tileBounds.y],
          [tileBounds.x + tileSize.x, tileBounds.y + tileSize.y],
        ]).intersects(bounds as L.Bounds) ||
        L.bounds([
          [tileBounds.x, tileBounds.y],
          [tileBounds.x + tileSize.x, tileBounds.y + tileSize.y],
        ]).contains(bounds) ||
        (bounds instanceof L.Bounds &&
          bounds.contains(
            L.bounds([
              [tileBounds.x, tileBounds.y],
              [tileBounds.x + tileSize.x, tileBounds.y + tileSize.y],
            ])
          ))
      ) {
        const filteredFeatures = boundPoints.filter(
          (pointFeature: { point: any }) => {
            const pointObj = pointFeature.point
            return (bounds as L.Bounds).contains(pointObj)
          }
        )
        features = features.concat(filteredFeatures)
      }
    }
    return features
  },
  getDrawFeaturesCount() {
    let count = 0
    for (const tileKey in this._tiles) {
      const points = this._tiles[tileKey].el.points
      if (points) {
        count += points.length
      }
    }
    return count
  },
  getColorByType(feature: any) {
    const type = this.getFeatureProperty(feature, 'type')
    if (type === '' || this.options.laneOptions.colorByType === null) {
      return this.options.laneOptions.colorByDefault
    }
    const typeNumber = Number.parseInt(type)
    return (
      this.options.laneOptions.colorByType[typeNumber] ||
      this.options.laneOptions.colorByDefault
    )
  },
  loadArrayBuffer(url: string, signal: any) {
    return fetch(url, { signal }).then((response) => {
      if (response.ok) {
        return response.arrayBuffer()
      }
      if (response.status !== 404) {
        throw this.err(url, response.status, response.statusText)
      }
    })
  },
  loadJson(url: string, signal: any) {
    return fetch(url, { signal }).then((response) => {
      if (response.ok) {
        return response.json()
      }
      if (response.status !== 404) {
        throw this.err(url, response.status, response.statusText)
      }
      throw new Error('Network response was not ok.')
    })
  },
  err(...args: any[]) {
    return new Error(args.join(': '))
  },
  rotate(point: { x: any; y: any }, angle: number) {
    const x = point.x
    const y = point.y
    const sin = Math.sin(angle)
    const cos = Math.cos(angle)
    return L.point([x * cos - y * sin, x * sin + y * cos])
  },
  // 绘制框线
  drawTileBox(
    context: {
      save: () => void
      globalAlpha: number
      lineWidth: number
      strokeStyle: string
      fillStyle: string
      fillText: (arg0: string, arg1: number, arg2: number) => void
      fillRect: (arg0: number, arg1: number, arg2: number, arg3: number) => void
      moveTo: (arg0: number, arg1: number) => void
      lineTo: (arg0: number, arg1: any) => void
      stroke: () => void
      restore: () => void
    },
    coords: { x: any; y: any; z: any; scaleBy: (arg0: any) => any }
  ) {
    const tileSize = this.getTileSize()

    context.save()
    context.globalAlpha = 1
    context.lineWidth = 1
    // context.fillRect(0, 0, tileSize.x, 50)
    context.strokeStyle = 'red'
    context.fillStyle = 'red'
    context.fillText(
      `x: ${coords.x}, y: ${coords.y}, zoom: ${coords.z}`,
      20,
      20
    )
    context.moveTo(0, 0)
    context.lineTo(0, tileSize.y)
    context.lineTo(tileSize.x, tileSize.y)

    context.stroke()
    context.restore()
  },
  getFeatureProperty(
    feature: { properties: { [x: string]: any } | null } | null,
    key: string | number
  ) {
    const fieldMap = this.options.laneOptions.fieldMap || {
      name: 'name',
      mmsi: 'mmsi',
      type: 't',
      sog: 's',
      hdg: 'h',
      cog: 'c',
      naviStatus: 'n',
      utc: 'u',
      key: 'k',
    }
    if (feature === null || feature.properties === null) {
      console.error('Error feature or feature.properties is null.')
      return ''
    }
    return feature.properties[fieldMap[key] || key] || ''
  },
}) as any

const canvasShip = (url: any, options: any) => {
  const canvasShipLayer = new CanvasShipLayer(url, options)
  return canvasShipLayer
}

export { CanvasShipLayer, canvasShip }
